import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import compose from 'lodash.flowright';

import Spinner from '../../../global/Spinner';
import PrepaidItemsPurchase from '../../../global/PrepaidItemsPurchaseModal/PrepaidItemsPurchase';
import useDiscoverAlbumFolderPrepaidItems from '../../../discover/DiscoverAlbumFolderPrepaidItems/hooks/useDiscoverAlbumFolderPrepaidItems';

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      albumFolderId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

const AlbumFolderPurchasePrePurchase = ({ history, location, match }) => {
  const { albumFolderId } = match.params;
  const { fromDiscovery } = location.state ?? {};
  const { user, loading } = useDiscoverAlbumFolderPrepaidItems({
    albumFolderId,
  });

  if (loading || !user) {
    return (
      <div className="w-100 h-100vh d-flex align-items-center justify-content-center">
        <Spinner />
      </div>
    );
  }

  return (
    <Fragment>
      <PrepaidItemsPurchase
        isOnboarding
        albumFolderId={albumFolderId}
        onCheckout={() => {
          if (fromDiscovery) {
            history.replace(`/discover/album-folder/${albumFolderId}/summary`);
          } else {
            history.replace(
              `/purchase/album-folder/${albumFolderId}/purchase-summary`,
            );
          }
        }}
        onAddFace={() =>
          history.push(`/discover/album-folder/${albumFolderId}/faces`)
        }
      />
    </Fragment>
  );
};

AlbumFolderPurchasePrePurchase.propTypes = propTypes;

export default compose(withRouter)(AlbumFolderPurchasePrePurchase);
